import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png/'
import _imports_1 from '@/assets/user/defaultavatar.png'


const _hoisted_1 = { class: "main-header" }
const _hoisted_2 = { class: "user-info" }

import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox, ElMessage } from "element-plus";
import { useUserInfoStore } from "@/stores/userInfo";
import { useOAuthStore } from "@/stores/oauth";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreatorHeader',
  setup(__props) {

const router = useRouter();
const userStore = useUserInfoStore();
const oauthStore = useOAuthStore();
onMounted(async () => {
console.log('create in');

});

// 退出登录
const logout = () => {
  ElMessageBox.confirm(
    "确定登出吗？程序员正在改变世界，我们需要你和我们在一起！",
    "温馨提示",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }
  )
    .then(async () => {
      //清除 userinfo token
      oauthStore.clearToken();
      userStore.clearUser();
      localStorage.clear();
      router.push("/").then(() => {
        location.reload();
      });
      ElMessage.success("退出登录成功！");
    })
    .catch(() => {
      //错误捕获
    });
};

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "logo" }, [
      _createElementVNode("a", { href: "/" }, [
        _createElementVNode("img", {
          src: _imports_0,
          height: "37",
          width: "152"
        })
      ]),
      _createElementVNode("span", { class: "header-span" }, "创作者中心")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_dropdown, { trigger: "click" }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { icon: "Setting" }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("a", { href: "/user/settings/profile" }, "我的设置", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, {
                icon: "TurnOff",
                onClick: logout
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("退出登录")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            class: "avatar",
            src: _imports_1
          }, null, -1))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})